<template>
    <el-row :gutter="20" style="padding: 60px;">
       
        <div style="display: flex;margin-bottom: 20px;">
              <img :src="head" class="headimg"/>
              <div class="pdl40" style="">
                <div class="subtitle" style="font-weight: 600;font-size: 24px;">账号：{{ username }}</div>
                <div class="colorgray">个性签名：{{ userinfo.UnderWrite }}</div>
              </div>
        </div>
        <div class="el-line-h"></div>
        <span class="subtitle pdl40"><i class="el-icon-lx-mobile"></i>手机号码：</span><span class="subtitle pdl40 colorgray">***********</span>
        <div class="el-line-h"></div>
        <span class="subtitle pdl40"><i class="el-icon-lx-profile"></i>实名认证：</span><span class="subtitle pdl40 colorgray">*****************</span>
        <div class="el-line-h"></div>
      
       
    </el-row>

</template>

<script>

import netutil from "../../common/netutil.js";
import accounts from '../../common/accounts.js';
export default {
    name: "myaccount",
    data() {
        return {

        };
    },
    components: {

    },
    computed: {
        username() {            
            return accounts.Accounts();
        },
        head()
        {
            return accounts.HeadImg();
        },
        userinfo()
        {            
            return accounts.Info();
        },
       
        
    },
    created() {

    },
    activated() {

    },
    deactivated() {

    },
    methods: {


    }
};
</script>


<style scoped>
.el-row {
    margin-bottom: 20px;
}

.title {
    font-size: 32px;
    width: 100%;
    text-align: center;
    line-height: 50px;
    font-weight: 400;
    color: #ff8800;
}

.subtitle {
    font-size: 20px;
    line-height: 60px;
    font-weight: 400;
}

.subcontent {
    font-size: 18px;
    line-height: 30px;
    color: rgb(124, 124, 124);
    padding-left: 20px;
    margin-bottom: 30px;
}

.el-icon-star-on
{
    color: #ffa01b;
}

.headimg
{
    width: 100px;
    height: 100px;
    border-radius: 100%;
    border: 2px solid #848484;
    margin-left: 30px;
}

.pdl40{
    padding-left: 40px;
}

.colorgray{
   color: #777777;
}
</style>
